import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ChaosService {

  constructor(private http: HttpClient) { }

  getServices(_searchText?: string | number) {
    // const searchTesxt = _searchText ? `?name=${_searchText}` : '';
    return this.http.get<any>(`${environment.apiUrl}chaosService?name=${_searchText}`);
  }

  getCSO(id: number) {
    return this.http.get<any>(`${environment.apiUrl}chaosService/${id}/cso`);
  }

  getDefaultData(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/projectMetaData?projectId=${projectId}`);
  }

  saveStepOne(obj) {
    return this.http.post<any>(`${environment.apiUrl}chaosSimulator/projectMetaData`, obj);
  }

  updateStepOne(obj) {
    return this.http.put<any>(`${environment.apiUrl}chaosSimulator/projectMetaData`, obj);
  }

  getChaosInfra(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/chaosProjectInfraDetails?projectId=${projectId}`);
  }

  saveChaosInfra(projectId: number, obj: any) {
    return this.http.post<any>(`${environment.apiUrl}chaosSimulator/chaosProjectInfraDetails?projectId=${projectId}`, obj);
  }

  updateChaosInfra(projectId: number, obj: any) {
    return this.http.put<any>(`${environment.apiUrl}chaosSimulator/chaosProjectInfraDetails?projectId=${projectId}`, obj);
  }

  getresults(projectId: number, generate: boolean) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/useCaseScenarios?projectId=${projectId}&generate=${generate}`);
  }

  saveResults(projectId: number, obj) {
    return this.http.put<any>(`${environment.apiUrl}chaosSimulator/useCaseScenarios?projectId=${projectId}`, obj);

  }

  downloadTemplatePDF(attack, prefferedTool, project) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/runBook/download?attack=${attack}&chaosTool=${prefferedTool}&projectId=${project.id}`);
  }

  sendEmail(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/email/useCases?projectId=${projectId}`);
  }

  notifyEmail(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/email/notify/qecoe?projectId=${projectId}`);
  }

  getAuditTrail(obj){
    return this.http.post<any>(`${environment.apiUrl}chaosSimulator/activities`,obj)
  }
  sendFeedBack(feedBack : any){
    return this.http.post<any>(`${environment.apiUrl}chaosSimulator/feedback/new`,feedBack);

  }

  getFeedBack(feedBack : any){
    return this.http.post<any>(`${environment.apiUrl}chaosSimulator/feedback`,feedBack);
  }

  recordChaosVisit() {
    return this.http.get<any>(`${environment.apiUrl}chaosSimulator/recordChaosVisit`);
  }
}
